export default {
  pageText: 'Deposit turnover',
  titleText: 'Deposit turnover',

  // tb columns
  columnsId: 'ID',
  columnsChangeData: 'Date of change',
  columnsAmount: 'Amount',
  columnsUnit: 'Unit',
  columnsDirection: 'Changes',
  columnsBalanceBeforeChange: 'Former Balance',
  columnsBalanceAfterChange: 'Curent Balance',
  columnsReason: 'Reason for change',
  columnsSource: 'Relatives',

  credit: 'Deposit',
  punishment: 'Penalty',
  AfterSalesDeduction: 'After-sales deduction',
  return: 'return',

  // search
  changeDirection: 'Changes',
  direction: {
    all: 'All',
    outlay: 'expenditure',
    credit: 'Credit'
  }
}
